<template>
	<div class="container__accordion">
		<div
			class="container__accordion__label"
			:class="{ warn: $attrs.warning === '' }"
			@click="switchAccordion"
		>
			<div
				class="container_accordion__label__title"
				:class="{ warn: $attrs.warning === '' }"
			>
				<p>{{ capitalized }}</p>
				<p
					v-if="hints.length"
					style="font-size: 0.7rem; font-weight: normal"
				>
					{{ hints.toString().split(',').join(', ') }}...
				</p>
			</div>
			<i :class="[`fas fa-angle-${showAccordion ? 'up' : 'down'}`, { active: showAccordion }]" />
		</div>
		<div
			v-if="showAccordion"
			:class="['container__accordion__content', { 'open--accordion': showAccordion }]"
		>
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		/**
		 * Label do que estará escrito acima do componente de Accordion
		 */
		label: {
			type: String,
		},

		/**
		 * Funcao que deve ser executada quando abre ou fecha o accordion
		 */
		onSwitchAccordion: {
			type: Function,
		},

		hints: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			showAccordion: false,
		}
	},
	computed: {
		capitalized() {
			return this.label.charAt(0).toUpperCase() + this.label.substring(1)
		},
	},
	methods: {
		/**
		 * Fecha o accordion
		 */
		closeAccordion() {
			this.showAccordion = false
		},

		/**
		 * Alterna entre mostrar ou nao o accordion
		 */
		switchAccordion() {
			this.showAccordion = !this.showAccordion
			if (this.onSwitchAccordion) this.onSwitchAccordion()
			//   if (this.showAccordion) {
			//     this.setDropdownDirection();
			//   }
		},
	},
}
</script>

<style>
.container__accordion__content {
	background-color: white;
	width: 100%;
	max-height: 0;
	overflow: hidden;
	overflow-y: auto;
	z-index: 1;
	transition: max-height 0.1s ease-in-out;
	margin-top: 0.5rem;
}

.container__accordion__content.open--accordion {
	max-height: 1000vh;
	overflow: visible;
}

.container__accordion__label {
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: var(--color-background);
	margin: 0;
	border-radius: 5px;
	font-size: 0.8rem;
	font-weight: bold;
	padding: 0.5rem;
}
.container__accordion__label.warn {
	background: var(--color-warning-message) !important;
}

.container_accordion__label__title p {
	margin: 0;
}

.container_accordion__label__title.warn {
	color: var(--color-warning-indicator);
}
</style>
